import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { OutlinedInput, FilledInput, InputLabel, MenuItem, FormHelperText, FormControl, SelectMaterialUI as Select } from '../../';
var useStyles = makeStyles(function () {
  return {
    formControl: {
      minWidth: 120
    },
    fullWidth: {
      width: '100%'
    }
  };
});

var SelectComponent = function SelectComponent(props) {
  var classes = useStyles();
  var inputLabel = React.useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  React.useEffect(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);
  var items = props.items ? props.items.map(function (item) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: item.id,
      value: item.value
    }, item.label);
  }) : null;
  var input;
  var variant = props.variant;

  switch (props.variant) {
    case 'filled':
      input = /*#__PURE__*/React.createElement(FilledInput, {
        labelWidth: labelWidth,
        name: props.name,
        id: props.idInput
      });
      break;

    case 'outlined':
      input = /*#__PURE__*/React.createElement(OutlinedInput, {
        labelWidth: labelWidth,
        name: props.name,
        id: props.idInput
      });
      break;

    default:
      variant = 'outlined';
      input = /*#__PURE__*/React.createElement(OutlinedInput, {
        labelWidth: labelWidth,
        name: props.name,
        id: props.idInput
      });
      break;
  }

  return /*#__PURE__*/React.createElement(FormControl, {
    variant: variant,
    className: props.fullWidth ? classes.formControl : classes.fullWidth
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.idInput,
    ref: inputLabel
  }, props.labelInput), /*#__PURE__*/React.createElement(Select, {
    value: props.value,
    onChange: props.handleChange,
    input: input,
    disabled: props.disabled
  }, items), props.helperText && /*#__PURE__*/React.createElement(FormHelperText, null, props.helperText));
};

export default SelectComponent;